// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".video-dialog{box-shadow:none}.video-dialog,.video-iframe{background-color:transparent}video{border:none;outline:none}", ""]);
// Exports
module.exports = exports;
